<template>
	<div style="position: relative;">
		<v-container fluid class="text-center banner1 d-flex flex-column align-center justify-center">
			<v-carousel cycle hide-delimiter-background show-arrows-on-hover :height="content.height" class="w-100">
				<v-carousel-item v-for="(item, idx) in content.slides" :key="idx" :style="item.img ? {
					backgroundImage: `url('${item.img.src}')`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
					width: '100%',
					height: '100%'
				} : {}">
					<div class="text-center w-100 h-100 d-flex flex-column align-center justify-center" style="background: rgba(255,255,255,0.0);padding: 24px 0;">
						<h1 class="primary--text font-weight-bold fs-h1">{{ item.title1 }}</h1>
						<p class="orange--text pt-4 fs-h3">{{ item.title2 }}</p>
					</div>
				</v-carousel-item>
			</v-carousel>
		</v-container>

		<div v-if="editable" style="position: absolute;top: 0; left: 0;">
			<v-btn small color="secondary" outlined @click="edit()">ویرایش</v-btn>
		</div>

		<v-dialog v-model="settingsDialog" persistent max-width="650px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تنظیمات اسلایدر</span></div>
					<v-spacer />
					<v-btn @click="settingsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field dense v-model="settings.height" type="number" label="ارتفاع اسلایدر"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card color="#eee" elevation="0" v-for="(slide, idx) in settings.slides" :key="idx" class="mb-3">
									<v-card-title class="d-flex justify-space-between">
										<h3>اسلایدر {{ idx + 1 }}</h3>
										<v-btn color="red" text small @click="removeSlide(idx)">حذف</v-btn>
									</v-card-title>
									<v-divider></v-divider>
									<v-card-text>
										<v-row>
											<v-col cols="12" md="4">
												<ImageUploader :ref="'imageUploader' + idx" v-model="slide.img.src" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(slide.img.src)" @delete="() => { slide.img.src = '' }" />
											</v-col>
											<v-col cols="12" md="8">
												<div>
													<v-text-field dense v-model="slide.title1" label="تایتل 1"></v-text-field>
												</div>
												<div>
													<v-text-field dense v-model="slide.title2" label="تایتل 2"></v-text-field>
												</div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
								<div class="px-3 text-center">
									<v-btn small color="secondary" @click="addSlide()">افزودن اسلاید</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="settingsDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" dark @click="submitEdit" :loading="submitEditLoading">
						ذخیره
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { cloneDeep, isEmpty } from 'lodash'
	import { siteContentRootPath } from '@/util/enums'
	import { get } from 'vuex-pathify'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'


	export default {
		name: 'NafisSlider1',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean }
		},
		components: {
			ImageUploader
		},
		data: () => ({
			settings: {},
			localData: null,
			settingsDialog: false,
			submitEditLoading: false
		}),
		computed: {
			...get('siteConfig', [
				'customerCode'
			]),
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			}
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content)
				}
			}
			else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent()
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					height: 500,
					slides: [{
						title1: 'لندتک نفیس',
						title2: 'تنها پلتفرم آنلاین با بیش از ۲۰ طرح آنلاین',
						img: { val: '', type: 'img', src: '/NafisTheme/banner1-right.webp' }
					}]
				}
			},
			edit() {
				this.settingsDialog = true
				this.settings = cloneDeep(this.content)
			},
			submitEdit() {
				this.submitEditLoading = true
				this.processImages().then(res => {
					const data = cloneDeep(this.localData)
					data.content = JSON.stringify(this.settings)
					api.post(`admin/SiteContent/CreateUpdate`, data)
						.then(response => {
							this.localData.content = cloneDeep(this.settings)
							toast.success('اطلاعات با موفقیت ذخیره شد.')
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => { })
				}).catch(err => { })
					.finally(f => {
						this.submitEditLoading = false
						this.settingsDialog = false
					})
			},
			removeSlide(idx) {
				this.settings.slides.splice(idx, 1)
			},
			addSlide() {
				this.settings.slides.push({
					title1: { val: '', type: 'text' },
					title2: { val: '', type: 'text' },
					img: { val: '', type: 'img', src: '' }
				})
			},
			processImages() {
				return new Promise(async (resolve, reject) => {
					for (let i = 0; i < this.settings.slides.length; i++) {
						let slide = this.settings.slides[i]
						const formData = new FormData()
						var fileUploader = Array.isArray(this.$refs['imageUploader' + i]) ? this.$refs['imageUploader' + i][0] : null
						if (fileUploader && fileUploader.hasFile()) {
							formData.append(`File`, fileUploader.getFile())
							formData.append(`fileName`, slide.img.val)
							await api.post('admin/SiteContent/CreateUpdateImage', formData, { contentType: 'multipart/form-data' })
								.then(response => {
									slide.img.val = response
									slide.img.src = `${siteContentRootPath}${this.ccode}/${response}`
								})
								.catch(err => {
									toast.error(err.message)
									reject()
								})
								.finally(x => { })
						} else if (slide.img.val && !slide.img.src) {
							await api.post('admin/SiteContent/DeleteImage', { fileName: slide.img.val })
								.catch(err => {
									toast.error(err.message)
									reject()
								})
						}
					}
					resolve()
				})
			}
		},
	}
</script>

<style lang="scss"></style>